import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap-theme.min.css'; // boostrap@3
// import 'bootstrap/dist/css/bootstrap.css'; //bootstrap@4
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
//import './base.scss'
import './index.css'

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js